<template>
  <md-popup :mask-closable="false" v-model="showInviteCodePopup">
    <div class="component-inputInviteCodePopup">
      <div class="invite-title">填写推广码</div>
      <div class="inviteCode-wrap">
        <input class="inviteCode" placeholder="输入推广码" type="tel" maxlength="16" v-model="inviteCode" @blur="handleInputBlur()" />
        <md-icon class="icon-clear" name="clear" size="md" @click="inviteCode = ''" v-show="inviteCode.length > 0"></md-icon>
      </div>
      <div class="btn-commit" :class="{ disable: inviteCode.length === 0 }" @click="handleClickNext()">下一步</div>
      <div class="btn-close" @click="showInviteCodePopup = false">
        <md-icon name="close" size="md"></md-icon>
      </div>
    </div>
  </md-popup>
</template>

<script>
import { Toast, Popup, Icon } from 'mand-mobile'
export default {
  name: 'inputInviteCodePopup',
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
  },
  data() {
    return {
      showInviteCodePopup: false,
      inviteCode: '',
    }
  },
  methods: {
    /**
     * 点击下一步
     */
    handleClickNext() {
      if (this.inviteCode.length === 0) {
        Toast.info('请输入推广码', 1000)
      } else {
        this.$http.user.checkInviteCode(this.inviteCode).then(res => {
          this.$emit('next', this.inviteCode)
        })
      }
    },
    /**
     * 输入框失去焦点(键盘收回)
     */
    handleInputBlur() {
      setTimeout(() => {
        // 解决ios微信中,input输入后,收回键盘时,页面无法自动滚动到原来位置,如果不手动上下滑动页面, 整个页面会假死，无法触发事件
        let curScrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let diff = 0.01 // 滚动偏差
        let top = curScrollTop >= diff ? curScrollTop - diff : curScrollTop + diff
        document.body.scrollTo(0, top) // 检测到收回键盘时,自动滚动页面到原来位置+-0.01的位置
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.component-inputInviteCodePopup {
  // 输入邀请码弹窗
  position: relative;
  width: 100%;
  min-width: 5.6rem;
  padding: 0.5rem 0.5rem 0.6rem;
  background: #fff;
  border-radius: 0.06rem;
  text-align: center;
  font-size: 0.28rem;
  .invite-title {
    font-weight: 600;
    font-size: 0.32rem;
  }
  .inviteCode-wrap {
    margin-top: 0.6rem;
    position: relative;
    height: 0.8rem;
    display: flex;
    align-items: center;
    border-radius: 0.14rem;
    padding: 0.04rem 0.3rem;
    border: 0.04rem solid #f8f8f8;
    box-shadow: 0 0.02rem 0.02rem 0 rgba(0, 0, 0, 0.05);
    .inviteCode {
      // 推广码
      width: 100%;
      height: 0.72rem;
      line-height: 0.4rem;
      padding: 0.16rem 0;
      font-size: 0.28rem;
      text-align: center;
      &::-webkit-input-placeholder {
        color: #aab2bd;
        font-size: 0.28rem;
      }
    }
    .icon-clear {
      position: absolute;
      right: 0.2rem;
      top: 50%;
      height: 0.4rem;
      line-height: 0.4rem;
      text-align: center;
      width: 0.4rem;
      margin-top: -0.18rem;
      color: #e8e8e8;
    }
  }
  .btn-close {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.76rem;
    height: 0.76rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    &:active {
      opacity: 0.3;
    }
  }
  .btn-commit {
    margin-top: 0.6rem;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(to left, #ff1a1a, #fd2b6b);
    border-radius: 0.4rem;
    &.disable,
    &:active {
      opacity: 0.3;
    }
  }
}
</style>
